import type { ReactElement, ReactNode } from 'react';
import { Box, Icon } from '@cloudscape-design/components';

import { BBBIcon } from './icons/BBBIcon';
import { BookingIcon } from './icons/BookingIcon';
import { CarFaxIcon } from './icons/CarFaxIcon';
import { CarGurusIcon } from './icons/CarGurusIcon';
import { CarsComIcon } from './icons/CarsComIcon';
import { DealerRaterIcon } from './icons/DealerRaterIcon';
import { EdmundsIcon } from './icons/EdmundsIcon';
import { ExpediaIcon } from './icons/ExpediaIcon';
import { GolfPassIcon } from './icons/GolfPassIcon';
import { GoogleIcon } from './icons/GoogleIcon';
import { OpenTableIcon } from './icons/OpenTableIcon';
import { TripAdvisorIcon } from './icons/TripAdvisorIcon';
import { YelpIcon } from './icons/YelpIcon';

const SOURCE_DISPLAY_NAMES: Record<string, string> = {
  google: 'Google',
  yelp: 'Yelp',
  bbb: 'BBB',
  dealerrater: 'DealerRater',
  opentable: 'OpenTable',
  tripadvisor: 'TripAdvisor',
  carscom: 'Cars.com',
  carfax: 'CarFax',
  edmunds: 'Edmunds',
  cargurus: 'CarGurus',
  booking: 'Booking.com',
  expedia: 'Expedia',
  golfpass: 'GolfPass',
};

export const SCORECARD_SOURCE_ORDER = [
  'google',
  'yelp',
  'bbb',
  'dealerrater',
  'carscom',
  'carfax',
  'edmunds',
  'cargurus',
  'opentable',
  'tripadvisor',
  'booking',
  'expedia',
  'golfpass',
];

const SOURCE_ICONS: Record<string, ReactElement> = {
  google: <GoogleIcon />,
  yelp: <YelpIcon />,
  bbb: <BBBIcon />,
  dealerrater: <DealerRaterIcon />,
  opentable: <OpenTableIcon />,
  tripadvisor: <TripAdvisorIcon />,
  carscom: <CarsComIcon />,
  carfax: <CarFaxIcon />,
  edmunds: <EdmundsIcon />,
  cargurus: <CarGurusIcon />,
  booking: <BookingIcon />,
  expedia: <ExpediaIcon />,
  golfpass: <GolfPassIcon />,
};

export function scorecardSourceName(source: string): string {
  const normalized = source.toLowerCase();
  return SOURCE_DISPLAY_NAMES[normalized]
    ?? `${normalized.charAt(0).toUpperCase()}${normalized.slice(1)}`;
}

export function scorecardSourceIcon(source: string): ReactNode {
  return SOURCE_ICONS[source.toLowerCase()] ?? <GoogleIcon />;
}

export function scorecardSourceSortIndex(source: string): number {
  const index = SCORECARD_SOURCE_ORDER.indexOf(source.toLowerCase());
  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
}

export function ScorecardSourceLabel({ source }: { source: string }) {
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap">
      <Icon svg={scorecardSourceIcon(source) as ReactElement} />
      <Box variant="span">{scorecardSourceName(source)}</Box>
    </span>
  );
}
